import { Moon, Sun } from 'lucide-react';
import { useTheme } from './ThemeContext';

/**
 * Sun/moon icon button that flips dark ↔ light. Lives in the
 * dashboard rail. The auth shell never renders this - it's
 * dark-locked.
 */
export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const next = theme === 'dark' ? 'light' : 'dark';
  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={toggle}
      title={`Switch to ${next} theme`}
      aria-label={`Switch to ${next} theme`}
    >
      {theme === 'dark' ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
}
